// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_core__Toast from "../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";

function sendGrpcErrorToast(dispatchToasts, err, message) {
  const __x = err.fieldViolations;
  const violations = Belt__Belt_List.reduce(__x, "", (function (acc, v) {
          return acc + (v.field + " ");
        }));
  Curry._1(dispatchToasts, {
        TAG: /* Add */0,
        _0: {
          id: Buhta_core__Toast.generateId(undefined),
          text: message + (" " + violations),
          kind: "warning",
          onClick: (function (param) {
              
            })
        }
      });
}

function sendToastHrmEvents(dispatchToasts, err, message, date) {
  const __x = err.fieldViolations;
  const violations = Belt__Belt_List.reduce(__x, "", (function (acc, v) {
          return v.field + " ";
        }));
  const blankViolation = violations.toLowerCase().includes("blank".toLowerCase(), undefined) ? "заполните дату изменений" : "";
  const previousViolation = violations.toLowerCase().includes("previous".toLowerCase(), undefined) ? "дата изменений должна быть после" + (" " + date) : "";
  Curry._1(dispatchToasts, {
        TAG: /* Add */0,
        _0: {
          id: Buhta_core__Toast.generateId(undefined),
          text: message + (" " + (blankViolation + previousViolation)),
          kind: "warning",
          onClick: (function (param) {
              
            })
        }
      });
}

function sendHrmEmployee(dispatchToasts, err, message) {
  const violations = err.errorMessage;
  const uniqueViolation = violations.toLowerCase().includes("exists".toLowerCase(), undefined) ? "пользователь с текущим ИИН уже существует" : "";
  console.log("err", violations);
  Curry._1(dispatchToasts, {
        TAG: /* Add */0,
        _0: {
          id: Buhta_core__Toast.generateId(undefined),
          text: message + (" " + uniqueViolation),
          kind: "warning",
          onClick: (function (param) {
              
            })
        }
      });
}

export {
  sendGrpcErrorToast ,
  sendToastHrmEvents ,
  sendHrmEmployee ,
}
/* Buhta_core__Toast Not a pure module */
